// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
			.floating-loader {
				position: fixed;
				bottom: 20px;
				right: 20px;
				background-color: rgba(0, 0, 0, 0.7);
				color: white;
				padding: 15px;
				border-radius: 8px;
				z-index: 1000;
				font-size: 14px;
				display: flex;
				align-items: center;
				gap: 10px;
			}

			.spinner {
				border: 4px solid rgba(255, 255, 255, 0.3);
				border-radius: 50%;
				border-top: 4px solid white;
				width: 24px;
				height: 24px;
				animation: spin 1s linear infinite;
			}

			@keyframes spin {
				0% {
					transform: rotate(0deg);
				}
				100% {
					transform: rotate(360deg);
				}
			}

			p {
				margin: 0; /* Remove margin to better align the text */
				line-height: 24px; /* Ensure vertical alignment with spinner */
			}
		`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
